import { render } from "./NewsCard.vue?vue&type=template&id=2f67ce8e&scoped=true"
import script from "./NewsCard.vue?vue&type=script&lang=js"
export * from "./NewsCard.vue?vue&type=script&lang=js"

import "./NewsCard.vue?vue&type=style&index=0&id=2f67ce8e&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f67ce8e"]])

export default __exports__